module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_6.ec9f6fe4.pdf";